module.exports = __webpack_public_path__ + "img/MW-tab.d6b7c532.jpg";